import { caliperDetailsService } from "@/business/caliperDetailsService";
import { configurationService } from "@/business/configurationService";
import BreadcrumbComponent from "@/components/commons/breadcrumb/BreadcrumbComponent.vue";

export default {
  components: {
    BreadcrumbComponent
  },
  name: 'CaliperDetailsDistanceComponent',
  data() {
    return {
      loading: false,
      distanceDetailsCharts: [],
      daysIndex: [],
      distanceChartDetails: [],
      initPosition: null,
      selectedReferences: [],
      model: {
        charts: [],
        maps: []
      }
    }
  },
  props: {
    thingDetails: {
      type: Object,
      required: true
    }
  },
  computed: {
  },
  methods: {
    onClickChartDays(data) {
      const index = data._index;
      const detailsdistance = caliperDetailsService.getDistanceDetailsHoursChart(this.thingDetails.data, this.thingDetails.hardware, this.daysIndex[index]);
      if(this.model.maps.length > 0) this.model.maps[0].name = this.$i18n.t("caliperSummary.map.name"),
      this.distanceChartDetails = detailsdistance.dates;
      this.distanceDetailsCharts.cleanAndUpdate(detailsdistance.charts);
    },
    async onClickChartHours(data) {
      const index = data._index;
      const hourSelected = this.distanceChartDetails[index];
      const map = await caliperDetailsService.getHoursDistanceMap(this.thingDetails.data.idThing, this.thingDetails.data.thingName, hourSelected.timestamp, hourSelected.timestamp + 3599, true);
      this.model.maps.cleanAndUpdate(map.maps);
      this.initPosition = map.initPosition;
    },
    onClickChartHoursDetails() {
    },
    onMapClick() {
    },
    async filtersChanged(data) {
      await configurationService.save("product.caliperDetails.distance.map", { currentLayer: data.currentLayer });
    },
    async positionAndZoomChanged(){
    }
  },
  created() {
  },
  async mounted() {
    this.loading = true;
    if (this.thingDetails && this.thingDetails.data && this.thingDetails.data.detailsBuckets.length > 0) {
      const report = await caliperDetailsService.generateDistanceDetailsReport(this.thingDetails.data, this.thingDetails.hardware);
      this.daysIndex = report.daysIndex;
      const detailsdistance = caliperDetailsService.getDistanceDetailsHoursChart(this.thingDetails.data, this.thingDetails.hardware, this.daysIndex[0]);
      this.distanceChartDetails = detailsdistance.dates;
      const mapData = await caliperDetailsService.getHoursDistanceMap(this.thingDetails.data.idThing, this.thingDetails.data.thingName, detailsdistance.dates[0].timestamp, detailsdistance.dates[0].timestamp + 3599);
      this.initPosition = mapData.initPosition;
      this.model.charts.cleanAndUpdate(report.charts);
      this.distanceDetailsCharts.cleanAndUpdate(detailsdistance.charts);
      this.model.maps.cleanAndUpdate(mapData.maps);
    }
    this.loading = false;
  }
}
